module.exports = __webpack_public_path__ + "img/1.dd6f88f.png";